import React from 'react'
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import CloseIcon from '@mui/icons-material/Close'
import { TemplateConfig, getTemplatesByType } from '../constants/templateConfig'

interface TemplateDrawerProps {
  open: boolean
  onClose: () => void
  converterType: 'price' | 'zone'
  onViewTemplateLink: (template: TemplateConfig) => void
}

const TemplateDrawer: React.FC<TemplateDrawerProps> = ({
  open,
  onClose,
  converterType,
  onViewTemplateLink
}) => {
  const title =
    converterType === 'price' ? 'Price Sheet Templates' : 'Zone Sheet Templates'

  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <Box sx={{ width: 500, p: 3 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}>
          <Typography variant='h6'>{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ mb: 3 }}>
          <List disablePadding>
            {getTemplatesByType(converterType).map(template => (
              <ListItem key={template.id} disablePadding>
                <ListItemButton onClick={() => onViewTemplateLink(template)}>
                  <ListItemIcon>
                    <LaunchIcon color='primary' />
                  </ListItemIcon>
                  <ListItemText
                    primary={template.displayName}
                    secondary={template.description}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>

        <Box sx={{ mt: 3, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
          <Typography variant='subtitle2' color='primary' gutterBottom>
            Instructions:
          </Typography>
          <Typography variant='body2'>
            1. View template links to understand the required format
            <br />
            2. Upload your prepared file for conversion
            <br />
            3. Only the first worksheet in each template will be processed
            <br />
          </Typography>
        </Box>
      </Box>
    </Drawer>
  )
}

export default TemplateDrawer
